import { METRICS_OCCUPANCY_RATE_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: METRICS_OCCUPANCY_RATE_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkMetricsOccupancyRate'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/metricsOccupancyRate/index.js